import React from "react";
import {
  ChevronDoubleLeftIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronDoubleRightIcon,
} from "@heroicons/react/24/outline";

const getPageWindow = (page, totalPages, windowSize = 5) => {
  let start = Math.max(1, page - Math.floor(windowSize / 2));
  const end = Math.min(totalPages, start + windowSize - 1);
  start = Math.max(1, end - windowSize + 1);
  const pages = [];
  for (let i = start; i <= end; i++) pages.push(i);
  return pages;
};

const btnBase =
  "inline-flex items-center justify-center h-9 min-w-9 px-2 rounded-md border border-gray-700 text-sm font-medium transition disabled:opacity-40 disabled:cursor-not-allowed bg-gray-800 text-gray-300 hover:bg-gray-700";

const Pagination = ({ page, totalPages, onPageChange, className = "" }) => {
  if (!totalPages || totalPages <= 1) return null;
  const pages = getPageWindow(page, totalPages);

  return (
    <nav className={`flex items-center justify-center gap-1 ${className}`}>
      <button
        type="button"
        className={btnBase}
        onClick={() => onPageChange(1)}
        disabled={page === 1}
        aria-label="First page"
      >
        <ChevronDoubleLeftIcon className="h-4 w-4" />
      </button>
      <button
        type="button"
        className={btnBase}
        onClick={() => onPageChange(page - 1)}
        disabled={page === 1}
        aria-label="Previous page"
      >
        <ChevronLeftIcon className="h-4 w-4" />
      </button>
      {pages.map((p) => (
        <button
          type="button"
          key={p}
          onClick={() => onPageChange(p)}
          className={`${btnBase} ${
            p === page ? "!bg-brand !text-white !border-brand" : ""
          }`}
          aria-current={p === page ? "page" : undefined}
        >
          {p}
        </button>
      ))}
      <button
        type="button"
        className={btnBase}
        onClick={() => onPageChange(page + 1)}
        disabled={page === totalPages}
        aria-label="Next page"
      >
        <ChevronRightIcon className="h-4 w-4" />
      </button>
      <button
        type="button"
        className={btnBase}
        onClick={() => onPageChange(totalPages)}
        disabled={page === totalPages}
        aria-label="Last page"
      >
        <ChevronDoubleRightIcon className="h-4 w-4" />
      </button>
    </nav>
  );
};

export default Pagination;
